import React, { useContext, useEffect, useState } from "react";
import "../../Tabels/Tabels.css";
import { Context } from "../../../../utils/context";
import Offcanvas from "react-bootstrap/Offcanvas";
import Card from "react-bootstrap/Card";
import Select from "react-select";
import { Row, Col, Form } from "react-bootstrap";

import ModalSave from "../../../common/ModalSave";
import Validation from "../../../common/FormValidation";
import { CancelButton, SaveButton } from "../../../common/Button";
import { TicketStatus } from "../../../../utils/apis/masters/masters";
import { Select2Data } from "../../../../utils/common";

// `.main-form-section` + `span.error-message` are what FormValidation looks for.
const Field = ({ label, children }) => (
  <div className="main-form-section mt-4">
    <Row className="align-items-start">
      <Form.Label column sm={3}>
        {label}
      </Form.Label>
      <Col sm={9}>
        {children}
        <span className="error-message"></span>
      </Col>
    </Row>
  </div>
);

const EditOffCanvance = (props) => {
  const { postData, getData, IMG_URL } = useContext(Context);

  const id = props.show;

  const [formData, setFormData] = useState({});
  const [ticketStatus, setTicketStatus] = useState([]);
  const [showModal, setShowModal] = useState({ code: 0, message: "" });

  // react-select passes the chosen option (which carries `name`), inputs pass an event
  const handleChange = (e) => {
    if (e?.name === "ticket_status_id") {
      setFormData({ ...formData, [e.name]: e });
    } else {
      setFormData({ ...formData, [e.target.name]: e.target.value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = Validation.FormValidation({
      classname: ".ticketsclass",
    });
    const validationErrorsSelect = Validation.SelectValidation({
      classname: ".ticketsclass",
    });

    if (validationErrors && validationErrorsSelect) {
      try {
        const response = await postData(
          `/ticket-management/tickets/${id}`,
          formData,
        );

        setShowModal({ code: response.code, message: response.message });
        setTimeout(() => {
          setShowModal({ code: 0, message: "" });
          props.handleClose();
        }, 1000);
      } catch (error) {
        console.error("Error submitting form:", error);
      }
    }
  };

  const GetEditData = async () => {
    const response = await getData(`/ticket-management/tickets/${id}`);
    setFormData({
      ...response?.data,
      ticket_status_id: {
        value: response?.data?.ticket_status_id,
        label: response?.data?.ticket_status?.name || "",
        name: "ticket_status_id",
      },
    });
  };

  const getMastersData = async () => {
    const res = await TicketStatus();
    setTicketStatus(await Select2Data(res?.data, "ticket_status_id"));
  };

  useEffect(() => {
    GetEditData();
    getMastersData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return (
    <>
      <Offcanvas
        show={props.show}
        style={{ width: "80%" }}
        placement="end"
        onHide={props.handleClose}
      >
        <Offcanvas.Header closeButton />
        <Offcanvas.Body>
          <Card className="shadow-lg p-3 mb-5 bg-white rounded">
            <Card.Body>
              <Card.Title>Edit Tickets</Card.Title>
              <hr />
              <Form
                onSubmit={handleSubmit}
                role="form"
                className="ticketsclass ticketStatusclass"
              >
                <Row>
                  <Col lg={10} md={12} className="mx-auto Add-content">
                    {/* Read-only ticket details: not `input-mandatory`, so an
                        empty value can never block saving the status. */}
                    <Field label="Ticket No">
                      <Form.Control
                        type="text"
                        name="ticket_no"
                        id="inputticket_no"
                        value={formData?.ticket_no || ""}
                        placeholder="Ticket No"
                        disabled
                        readOnly
                      />
                    </Field>

                    <Field label="Subject">
                      <Form.Control
                        type="text"
                        name="subject"
                        id="inputsubject"
                        value={formData?.subject?.name || ""}
                        placeholder="Subject"
                        disabled
                        readOnly
                      />
                    </Field>

                    <Field label="Title">
                      <Form.Control
                        type="text"
                        name="title"
                        id="inputtitle"
                        value={formData?.title || ""}
                        placeholder="Title"
                        disabled
                        readOnly
                      />
                    </Field>

                    <Field label="Description">
                      <Form.Control
                        as="textarea"
                        rows={3}
                        name="description"
                        id="inputdescription"
                        value={formData?.description || ""}
                        placeholder="Description"
                        disabled
                        readOnly
                      />
                    </Field>

                    {formData?.image && (
                      <div className="main-form-section mt-4">
                        <div className="text-center">
                          <img
                            src={IMG_URL + formData.image}
                            alt="Ticket screenshot"
                            className="img-fluid rounded shadow-sm"
                            style={{ maxWidth: "40%", maxHeight: "50vh" }}
                          />
                        </div>
                      </div>
                    )}

                    {/* Editable fields */}
                    <Field label="Ticket Status">
                      <Select
                        aria-label="Ticket Status"
                        name="ticket_status_id"
                        id="inputticket_status_id"
                        className="input-mandatory"
                        placeholder="Ticket Status"
                        options={ticketStatus}
                        value={formData?.ticket_status_id}
                        onChange={handleChange}
                      />
                    </Field>

                    <Field label="Remarks">
                      <Form.Control
                        as="textarea"
                        rows={4}
                        name="remarks"
                        id="inputremarks"
                        value={formData?.remarks || ""}
                        onChange={handleChange}
                        placeholder="Remarks"
                        className="input-mandatory"
                      />
                    </Field>

                    <div className="d-flex justify-content-center mt-5 pb-3">
                      <CancelButton
                        name="cancel"
                        handleClose={props.handleClose}
                      />
                      <SaveButton name="save" handleSubmit={handleSubmit} />
                    </div>
                  </Col>
                </Row>
              </Form>
            </Card.Body>
          </Card>
        </Offcanvas.Body>
      </Offcanvas>
      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};

export default EditOffCanvance;
